export default "__VITE_ASSET__BwQbZKqX__"